module.exports = __webpack_public_path__ + "img/Caesar.f4add7b0.jpg";